<template>
  <div class="container py-30">
    <h1 class="text-center mb-30">Demo TextEditor</h1>
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "demo-texteditor",
  data() {
    return {
    };
  },
  components: {
  },
  computed: {
    ...mapGetters({
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
};
</script>

<style global lang="scss">
/* Css Layout Component */
@import "../assets/scss/mwe/editor-main.scss";
</style>